import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Mode } from '@thirdweb-dev/chains';
import { getContract } from '@thirdweb-dev/react';
import nftMarketplaceAbi from 'abis/NFTMarketPlace.json';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

async function fetcher(config: ApplicationConfig | undefined) {
  if (!config) {
    return null;
  }

  try {
    const contract = await getContract({
      address: config.CONTRACTS.NFT_MARKETPLACE,
      network: Mode,
      contractTypeOrAbi: nftMarketplaceAbi
    });

    // @ts-ignore
    const res = await contract.call('BLIND_BID_REVEAL_WINDOW');

    return res;
  } catch (e) {
    console.error(e);

    return false;
  }
}

export function useGetRevealWindowForBlindAuction() {
  const config = useConfig();

  return useQuery(
    [QueryKeys.GET_REVEAL_WINDOW_FRO_BLIND_AUCTION, !!config],
    () => fetcher(config),
    {
      enabled: Boolean(config),
      staleTime: 30000
    }
  );
}
